export default {
	data () {
		return {
			categories: [
				{
					name: 'Сервисы',
					url: '/',
					items: [
						{
							title: 'Эскроу счёт',
							url: '/escrow/'
						},
						{
							title: 'Платежи и переводы',
							url: '/pay/'
						},
						{
							title: 'Биометрия',
							url: '/biometry/'
						}
					]
				},
				{
					name: 'Возможности',
					url: '/',
					items: [
						{
							title: 'Акции и партнеры',
							url: '#'
						},
						{
							title: 'Специальные предложения для клиентов Банка',
							url: '/partner-offers/'
						},
						{
							title: 'Сейфы',
							url: ''
						},
					]
				},
			],
			topMenu: [
				{
					title: 'Частным клиентам',
					url: '/'
				},
				{
					title: 'Бизнесу',
					url: '/corporate'
				},
				{
					title: 'Строительству',
					url: '/for-developers'
				},
				{
					title: 'Private',
					url: '/private-banking'
				}
			],
			mainMenu: [
				{
					title: 'Ипотека',
					url: '/mortgage'
				},
				{
					title: 'Кредиты',
					url: '/loans'
				},
				{
					title: 'Вклады',
					url: '/deposits'
				},
				{
					title: 'Карты',
					url: '/cards'
				},
				{
					title: 'Премиум',
					url: '/premium'
				}
			],
			showSearch: true
		}
	}
}
